// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"Image_imageWrapper__ex_vj","loading":"Image_loading__rJotM"};